import { Button, InfoBar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import type { SeatBasedTeamSubscription } from "../../../hooks/useTeamsTypes";
import { calculateDaysLeft } from "../../../utils/convertUtils";
import { formatExpirationDate } from "../subscriptionUtils";

export const TeamGracePeriodBanner: React.FC<{
  className?: string;
  subscription: SeatBasedTeamSubscription;
  handleUpdatePaymentInfo: () => void;
}> = ({ className, subscription, handleUpdatePaymentInfo }) => {
  const { teamID } = useParams();

  if (!subscription.gracePeriodExpirationDate || !teamID) {
    return null;
  }

  const gracePeriodDays = calculateDaysLeft(
    new Date(subscription.gracePeriodExpirationDate),
    new Date()
  );

  return (
    <InfoBar
      className={className}
      variant="critical"
      title={`Payment error - ${gracePeriodDays} day${
        gracePeriodDays === 1 ? "" : "s"
      } left in grace period`}
      text={
        <span>
          Update your card details to prevent losing access to Pro features. Your subscription will
          be automatically switched to Basic and{" "}
          <span>
            {subscription.editorSeatsUsed > 1
              ? `all ${subscription.editorSeatsUsed} team members `
              : "you "}
          </span>
          will lose access to the team on{" "}
          <b>{formatExpirationDate(subscription.gracePeriodExpirationDate)}</b>
        </span>
      }
      cta={
        <Button variant="grayscale" onClick={handleUpdatePaymentInfo}>
          Update card
        </Button>
      }
    ></InfoBar>
  );
};
